import { requirePermission } from '@/utils/auth'
import { createFileRoute, redirect } from '@tanstack/react-router'
import dayjs from 'dayjs'

export const Route = createFileRoute('/shifts')({
  beforeLoad: ({ location }) => {
    requirePermission('shifts')

    if (location.pathname === '/shifts' || location.pathname === '/shifts/') {
      const now = dayjs()
      const endDate = dayjs(now.toDate()).format('YYYY-MM-DD')
      const startDate = dayjs(now.toDate()).format('YYYY-MM-DD')

      throw redirect({
        to: '/shifts/$startDate/$endDate',
        params: {
          startDate,
          endDate,
        },
      })
    }
  },
})
